import { render, staticRenderFns } from "./addSurvey.vue?vue&type=template&id=59fc30f9&scoped=true&"
import script from "./addSurvey.vue?vue&type=script&lang=ts&"
export * from "./addSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./addSurvey.vue?vue&type=style&index=0&id=59fc30f9&lang=scss&scoped=true&"
import style1 from "./addSurvey.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fc30f9",
  null
  
)

export default component.exports